// extracted by mini-css-extract-plugin
module.exports = {"spaceBetween":"_1wR7U","waveformContainer":"_1hvkl","timeContainer":"_3L_Dm","icon":"_1K2DN","button":"_3wjDU","audioLength":"_2fgTD"};